import { AxiosError } from "axios";
import { axiosInstance } from "../../../../api/axiosInstance";
import { handleAxiosResponse } from "../../../../common/utils/axios_response";
import { isBaseError, toBaseError } from "../../../../common/utils/base_error";
import {
  GetAllContratoRequest,
  GetAllContratoResponse,
} from "../daos/read/get_all_contrato";
import { ITerceirizacaoService } from "./terceirizacao_service";
import {
  CreateContratoRequest,
  CreateContratoResponse,
} from "../daos/create/create_contrato";
import {
  UpdateContratoRequest,
  UpdateContratoResponse,
} from "../daos/update/update_contrato";
import {
  DeleteContratoRequest,
  DeleteContratoResponse,
} from "../daos/delete/delete_contrato";
import {
  CreateContratoServicoRequest,
  CreateContratoServicoResponse,
} from "../daos/create/create_contrato_servico";
import {
  GetAllContratoServicoRequest,
  GetAllContratoServicoResponse,
} from "../daos/read/get_all_contrato_servico";
import {
  UpdateContratoServicoRequest,
  UpdateContratoServicoResponse,
} from "../daos/update/update_contrato_services";
import {
  DeleteContratoServicoRequest,
  DeleteContratoServicoResponse,
} from "../daos/delete/delete_contrato_servico";
import {
  DeleteContratoArquivoRequest,
  DeleteContratoArquivoResponse,
} from "../daos/delete/delete_contrato_arquivo";
import {
  UpdateContratoArquivoRequest,
  UpdateContratoArquivoResponse,
} from "../daos/update/update_contrato_arquivo";
import {
  CreateContratoArquivoRequest,
  CreateContratoArquivoResponse,
} from "../daos/create/create_contrato_arquivo";
import {
  GetAllContratoArquivoRequest,
  GetAllContratoArquivoResponse,
} from "../daos/read/get_all_contrato_arquivo";
import {
  DeleteContratoInformacoesRequest,
  DeleteContratoInformacoesResponse,
} from "../daos/delete/delete_contrato_informacoes";
import {
  UpdateContratoInformacoesRequest,
  UpdateContratoInformacoesResponse,
} from "../daos/update/update_contrato_informacoes";
import {
  CreateContratoInformacoesRequest,
  CreateContratoInformacoesResponse,
} from "../daos/create/create_contrato_informacoes";
import {
  GetAllContratoInformacoesRequest,
  GetAllContratoInformacoesResponse,
} from "../daos/read/get_all_contrato_informacoes";
import {
  GetAllMedicaoRequest,
  GetAllMedicaoResponse,
} from "../daos/read/get_all_medicao";
import {
  DeleteMedicaoRequest,
  DeleteMedicaoResponse,
} from "../daos/delete/delete_medicao";
import {
  CreatMedicaoRequest,
  CreatMedicaoResponse,
} from "../daos/create/create_medicao";
import {
  UpdateMedicaoRequest,
  UpdateMedicaoResponse,
} from "../daos/update/update_medicao";
import {
  CreatArquivoGenericoRequest,
  CreatArquivoGenericoResponse,
} from "../daos/create/create_arquivo_generico";
import {
  UpdateArquivoGenericoRequest,
  UpdateArquivoGenericoResponse,
} from "../daos/update/update_arquivo_generico";
import {
  GetAllArquivoGenericoRequest,
  GetAllArquivoGenericoResponse,
} from "../daos/read/get_all_arquivo_generico";
import {
  GetAllConfigPagamentoRequest,
  GetAllConfigPagamentoResponse,
} from "../daos/read/get_all_config_pagamento";
import {
  UpdateConfigPagamentoRequest,
  UpdateConfigPagamentoResponse,
} from "../daos/update/update_config_pagamento";
import {
  CreatConfigPagamentoRequest,
  CreatConfigPagamentoResponse,
} from "../daos/create/create_config_pagamento";
import {
  DeleteConfigPagamentoRequest,
  DeleteConfigPagamentoResponse,
} from "../daos/delete/delete_config_pagamento";
import {
  DeleteItemMedicaoRequest,
  DeleteItemMedicaoResponse,
} from "../daos/delete/delete_item_medicao";
import {
  UpdateItemMedicaoRequest,
  UpdateItemMedicaoResponse,
} from "../daos/update/update_item_medicao";
import {
  CreatItemMedicaoRequest,
  CreatItemMedicaoResponse,
} from "../daos/create/create_item_medicao";
import {
  GetAllItemMedicaoRequest,
  GetAllItemMedicaoResponse,
} from "../daos/read/get_all_item_medicao";
import {
  GetAllMedicaoEntregaRequest,
  GetAllMedicaoEntregaResponse,
} from "../daos/read/get_all_medicao_entrega";
import {
  GetAllFuncionarioTercRequest,
  GetAllFuncionarioTercResponse,
} from "../daos/read/get_all_funcionario_terc";
import {
  AlterarInativoAtivoRequest,
  AlterarInativoAtivoResponse,
} from "../daos/update/alterar_inativo_ativo_funcionario";
import {
  DeleteFuncionariosTercRequest,
  DeleteFuncionariosTercResponse,
} from "../daos/delete/delete_funcionarios_terc";
import {
  UpdateFuncionariosTercRequest,
  UpdateFuncionariosTercResponse,
} from "../daos/update/update_funcionarios_terc";
import {
  CreatFuncionariosTercRequest,
  CreatFuncionariosTercResponse,
} from "../daos/create/create_funcionarios_terc";
import {
  CreatCentroCustoSecundarioRequest,
  CreatCentroCustoSecundarioResponse,
} from "../daos/create/create_centro_custo_secundario";
import {
  UpdateCentroCustoSecundarioRequest,
  UpdateCentroCustoSecundarioResponse,
} from "../daos/update/update_centro_custo_secundario";
import {
  GetCentroCustoSecundariosRequest,
  GetCentroCustoSecundariosResponse,
} from "../daos/read/get_centro_custo_secundarios";
import {
  DeleteCentroCustoSecundarioRequest,
  DeleteCentroCustoSecundarioResponse,
} from "../daos/delete/delete_centro_custo_secundario";
import {
  DeleteDocumentoRequest,
  DeleteDocumentoResponse,
} from "../daos/delete/delete_documento";
import {
  UpdateDocumentoRequest,
  UpdateDocumentoResponse,
} from "../daos/update/update_documento";
import {
  CreateDocumentoRequest,
  CreateDocumentoResponse,
} from "../daos/create/create_documento";
import {
  GetDocumentosRequest,
  GetDocumentosResponse,
} from "../daos/read/get_documentos";
import {
  GetFuncionarioTreinamentosRequest,
  GetFuncionarioTreinamentosResponse,
} from "../daos/read/get_treinamentos";
import {
  DeleteFuncionarioTreinamentoRequest,
  DeleteFuncionarioTreinamentoResponse,
} from "../daos/delete/delete_funcionario_treinamento";
import {
  CreateAvaliacaoTreinamentoRequest,
  CreateAvaliacaoTreinamentoResponse,
} from "../daos/create/create_avaliacao_treinamento";
import {
  UpdateAvaliacaoTreinamentoRequest,
  UpdateAvaliacaoTreinamentoResponse,
} from "../daos/update/update_treinamento";
import {
  AvaliarTreinamentoLoteRequest,
  AvaliarTreinamentoLoteResponse,
} from "../daos/create/avaliar_treinamento_lote";
import {
  AvaliarTreinamentoRequest,
  AvaliarTreinamentoResponse,
} from "../daos/create/avaliar_treinamento";
import {
  GetAllAvaliacaoTreinamentoLoteRequest,
  GetAllAvaliacaoTreinamentoLoteResponse,
} from "../daos/read/get_all_avaliacao_treinamento_lote";
import {
  GetAllTreinamentoFuncionarioRequest,
  GetAllTreinamentoFuncionarioResponse,
} from "../daos/read/get_all_treinamento_funcionario";
import {
  SaveTreinamentoFuncionarioRequest,
  SaveTreinamentoFuncionarioResponse,
} from "../daos/create/save_treinamento_funcionario";
import {
  GetAvaliacaoFornecedorRequest,
  GetAvaliacaoFornecedorResponse,
} from "../daos/read/get_avaliacao_fornecedor";
import {
  GetFormularioAvaliacaoFornecedorRequest,
  GetFormularioAvaliacaoFornecedorResponse,
} from "../daos/read/get_formulario_avaliacao_fornecedor";
import {
  UpdateAvaliacaoRequest,
  UpdateAvaliacaoResponse,
} from "../daos/update/update_avaliacao";
import {
  GetAllTreinamentoFuncionarioTercDataRequest,
  GetAllTreinamentoFuncionarioTercDataResponse,
} from "../daos/read/get_all_treinamento_funcionario_terc_data";
import {
  GetAllTreinamentoFuncionarioTercInstrutorRequest,
  GetAllTreinamentoFuncionarioTercInstrutorResponse,
} from "../daos/read/get_all_treinamento_funcionario_terc_instrutor";
import {
  GetAllTreinamentoFuncionarioTercLocalRequest,
  GetAllTreinamentoFuncionarioTercLocalResponse,
} from "../daos/read/get_all_treinamento_funcionario_terc_local";
import { DownloadFuncionarioDocumentoByIdRequest } from "../daos/read/download_funcionario_documento_by_id";
import { GetAllIndicadoresResponse } from "../daos/read/get_all_indicadores";
import { TercIndicadores } from "../../domain/models/terc_indicadores";
import { DownloadContratoArquivoRequest } from "../daos/read/download_contrato_arquivo";
import { RequestObjectToFormData } from "../../../../common/utils/form_data_utils";

export class TerceirizacaoService implements ITerceirizacaoService {
  //#region Contrato
  async getAllListagemContrato(
    request: GetAllContratoRequest,
  ): Promise<GetAllContratoResponse> {
    try {
      const result = await axiosInstance({}).post(
        `terceirizacao/contrato/listContrato`,
        request,
      );
      const response = handleAxiosResponse<GetAllContratoResponse>(result);
      return { ...response };
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }
  async createContrato(
    request: CreateContratoRequest,
  ): Promise<CreateContratoResponse> {
    try {
      const result = await axiosInstance({}).post(
        `terceirizacao/contrato/create`,
        request,
      );
      const response = handleAxiosResponse<CreateContratoResponse>(result);
      return { ...response };
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }
  async updateContrato(
    request: UpdateContratoRequest,
  ): Promise<UpdateContratoResponse> {
    try {
      const result = await axiosInstance({}).post(
        `terceirizacao/contrato/update`,
        request,
      );
      const response = handleAxiosResponse<UpdateContratoResponse>(result);
      return { ...response };
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }
  async deleteContrato(
    request: DeleteContratoRequest,
  ): Promise<DeleteContratoResponse> {
    try {
      const result = await axiosInstance({}).delete(
        `terceirizacao/contrato/delete`,
        { data: request },
      );
      const response = handleAxiosResponse<DeleteContratoResponse>(result);
      return { ...response };
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }
  //#endregion

  //#region Servico
  async getAllListagemContratoServico(
    request: GetAllContratoServicoRequest,
  ): Promise<GetAllContratoServicoResponse> {
    try {
      const result = await axiosInstance({}).post(
        `terceirizacao/contratoServico/listContratoServico`,
        request,
      );
      const response =
        handleAxiosResponse<GetAllContratoServicoResponse>(result);
      return { ...response };
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }
  async createContratoServico(
    request: CreateContratoServicoRequest,
  ): Promise<CreateContratoServicoResponse> {
    try {
      const result = await axiosInstance({}).post(
        `terceirizacao/contratoServico/create`,
        request,
      );
      const response =
        handleAxiosResponse<CreateContratoServicoResponse>(result);
      return { ...response };
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }
  async updateContratoServico(
    request: UpdateContratoServicoRequest,
  ): Promise<UpdateContratoServicoResponse> {
    try {
      const result = await axiosInstance({}).post(
        `terceirizacao/contratoServico/update`,
        request,
      );
      const response =
        handleAxiosResponse<UpdateContratoServicoResponse>(result);
      return { ...response };
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }
  async deleteContratoServico(
    request: DeleteContratoServicoRequest,
  ): Promise<DeleteContratoServicoResponse> {
    try {
      const result = await axiosInstance({}).delete(
        `terceirizacao/contratoServico/delete`,
        { data: request },
      );
      const response =
        handleAxiosResponse<DeleteContratoServicoResponse>(result);
      return { ...response };
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }
  //#endregion

  //#region Arquivo
  async getAllListagemContratoArquivo(
    request: GetAllContratoArquivoRequest,
  ): Promise<GetAllContratoArquivoResponse> {
    try {
      const result = await axiosInstance({}).post(
        `terceirizacao/contratoArquivo/listContratoArquivo`,
        request,
      );
      const response =
        handleAxiosResponse<GetAllContratoArquivoResponse>(result);
      return { ...response };
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }
  async createContratoArquivo(
    request: CreateContratoArquivoRequest,
  ): Promise<CreateContratoArquivoResponse> {
    try {
      const formData = RequestObjectToFormData(request);
      const options = { headers: { "Content-Type": "multipart/form-data" } };
      const result = await axiosInstance({}).post(
        `terceirizacao/contratoArquivo/create`,
        formData,
        options,
      );
      const response =
        handleAxiosResponse<CreateContratoArquivoResponse>(result);
      return { ...response };
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }
  async updateContratoArquivo(
    request: UpdateContratoArquivoRequest,
  ): Promise<UpdateContratoArquivoResponse> {
    try {
      const formData = RequestObjectToFormData(request);
      const options = { headers: { "Content-Type": "multipart/form-data" } };
      const result = await axiosInstance({}).post(
        `terceirizacao/contratoArquivo/update`,
        formData,
        options,
      );
      const response =
        handleAxiosResponse<UpdateContratoArquivoResponse>(result);
      return { ...response };
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }
  async deleteContratoArquivo(
    request: DeleteContratoArquivoRequest,
  ): Promise<DeleteContratoArquivoResponse> {
    try {
      const result = await axiosInstance({}).delete(
        `terceirizacao/contratoArquivo/delete`,
        { data: request },
      );
      const response =
        handleAxiosResponse<DeleteContratoArquivoResponse>(result);
      return { ...response };
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }
  //#endregion

  //#region Informacoes
  async getAllListagemContratoInformacoes(
    request: GetAllContratoInformacoesRequest,
  ): Promise<GetAllContratoInformacoesResponse> {
    try {
      const result = await axiosInstance({}).post(
        `terceirizacao/contratoInformacoes/listContratoInformacoes`,
        request,
      );
      const response =
        handleAxiosResponse<GetAllContratoInformacoesResponse>(result);
      return { ...response };
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }
  async createContratoInformacoes(
    request: CreateContratoInformacoesRequest,
  ): Promise<CreateContratoInformacoesResponse> {
    try {
      const result = await axiosInstance({}).post(
        `terceirizacao/contratoInformacoes/create`,
        request,
      );
      const response =
        handleAxiosResponse<CreateContratoInformacoesResponse>(result);
      return { ...response };
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }
  async updateContratoInformacoes(
    request: UpdateContratoInformacoesRequest,
  ): Promise<UpdateContratoInformacoesResponse> {
    try {
      const result = await axiosInstance({}).post(
        `terceirizacao/contratoInformacoes/update`,
        request,
      );
      const response =
        handleAxiosResponse<UpdateContratoInformacoesResponse>(result);
      return { ...response };
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }
  async deleteContratoInformacoes(
    request: DeleteContratoInformacoesRequest,
  ): Promise<DeleteContratoInformacoesResponse> {
    try {
      const result = await axiosInstance({}).delete(
        `terceirizacao/contratoInformacoes/delete`,
        { data: request },
      );
      const response =
        handleAxiosResponse<DeleteContratoInformacoesResponse>(result);
      return { ...response };
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }
  //#endregion

  //#region Medicao
  async getAllListagemMedicao(
    request: GetAllMedicaoRequest,
  ): Promise<GetAllMedicaoResponse> {
    try {
      const result = await axiosInstance({}).post(
        `terceirizacao/Medicao/listMedicao`,
        request,
      );
      const response = handleAxiosResponse<GetAllMedicaoResponse>(result);
      return { ...response };
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }
  async createMedicao(
    request: CreatMedicaoRequest,
  ): Promise<CreatMedicaoResponse> {
    try {
      const result = await axiosInstance({}).post(
        `terceirizacao/Medicao/create`,
        request,
      );
      const response = handleAxiosResponse<CreatMedicaoResponse>(result);
      return { ...response };
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }
  async updateMedicao(
    request: UpdateMedicaoRequest,
  ): Promise<UpdateMedicaoResponse> {
    try {
      const result = await axiosInstance({}).post(
        `terceirizacao/Medicao/update`,
        request,
      );
      const response = handleAxiosResponse<UpdateMedicaoResponse>(result);
      return { ...response };
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }
  async deleteMedicao(
    request: DeleteMedicaoRequest,
  ): Promise<DeleteMedicaoResponse> {
    try {
      const result = await axiosInstance({}).delete(
        `terceirizacao/Medicao/delete`,
        { data: request },
      );
      const response = handleAxiosResponse<DeleteMedicaoResponse>(result);
      return { ...response };
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  //#endregion

  //#region Arquivo Generico
  async getAllListagemArquivoGenerico(
    request: GetAllArquivoGenericoRequest,
  ): Promise<GetAllArquivoGenericoResponse> {
    try {
      const result = await axiosInstance({}).post(
        `terceirizacao/ArquivoGenerico/listArquivoGenerico`,
        request,
      );
      const response =
        handleAxiosResponse<GetAllArquivoGenericoResponse>(result);
      return { ...response };
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }
  async createArquivoGenerico(
    request: CreatArquivoGenericoRequest,
  ): Promise<CreatArquivoGenericoResponse> {
    try {
      const result = await axiosInstance({}).post(
        `terceirizacao/ArquivoGenerico/create`,
        request,
      );
      const response =
        handleAxiosResponse<CreatArquivoGenericoResponse>(result);
      return { ...response };
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }
  async updateArquivoGenerico(
    request: UpdateArquivoGenericoRequest,
  ): Promise<UpdateArquivoGenericoResponse> {
    try {
      const result = await axiosInstance({}).post(
        `terceirizacao/ArquivoGenerico/update`,
        request,
      );
      const response =
        handleAxiosResponse<UpdateArquivoGenericoResponse>(result);
      return { ...response };
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }
  //#endregion

  //#region ConfigPagamento
  async getAllListagemConfigPagamento(
    request: GetAllConfigPagamentoRequest,
  ): Promise<GetAllConfigPagamentoResponse> {
    try {
      const result = await axiosInstance({}).post(
        `terceirizacao/ConfigPagamento/listConfigPagamento`,
        request,
      );
      const response =
        handleAxiosResponse<GetAllConfigPagamentoResponse>(result);
      return { ...response };
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }
  async createConfigPagamento(
    request: CreatConfigPagamentoRequest,
  ): Promise<CreatConfigPagamentoResponse> {
    try {
      const result = await axiosInstance({}).post(
        `terceirizacao/ConfigPagamento/create`,
        request,
      );
      const response =
        handleAxiosResponse<CreatConfigPagamentoResponse>(result);
      return { ...response };
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }
  async updateConfigPagamento(
    request: UpdateConfigPagamentoRequest,
  ): Promise<UpdateConfigPagamentoResponse> {
    try {
      const result = await axiosInstance({}).post(
        `terceirizacao/ConfigPagamento/update`,
        request,
      );
      const response =
        handleAxiosResponse<UpdateConfigPagamentoResponse>(result);
      return { ...response };
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }
  async deleteConfigPagamento(
    request: DeleteConfigPagamentoRequest,
  ): Promise<DeleteConfigPagamentoResponse> {
    try {
      const result = await axiosInstance({}).delete(
        `terceirizacao/ConfigPagamento/delete`,
        { data: request },
      );
      const response =
        handleAxiosResponse<DeleteConfigPagamentoResponse>(result);
      return { ...response };
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }
  //#endregion

  //#region ItemMedicao
  async getAllListagemItemMedicao(
    request: GetAllItemMedicaoRequest,
  ): Promise<GetAllItemMedicaoResponse> {
    try {
      const result = await axiosInstance({}).post(
        `terceirizacao/ItemMedicao/listItemMedicao`,
        request,
      );
      const response = handleAxiosResponse<GetAllItemMedicaoResponse>(result);
      return { ...response };
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }
  async createItemMedicao(
    request: CreatItemMedicaoRequest,
  ): Promise<CreatItemMedicaoResponse> {
    try {
      const result = await axiosInstance({}).post(
        `terceirizacao/ItemMedicao/create`,
        request,
      );
      const response = handleAxiosResponse<CreatItemMedicaoResponse>(result);
      return { ...response };
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }
  async updateItemMedicao(
    request: UpdateItemMedicaoRequest,
  ): Promise<UpdateItemMedicaoResponse> {
    try {
      const result = await axiosInstance({}).post(
        `terceirizacao/ItemMedicao/update`,
        request,
      );
      const response = handleAxiosResponse<UpdateItemMedicaoResponse>(result);
      return { ...response };
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }
  async deleteItemMedicao(
    request: DeleteItemMedicaoRequest,
  ): Promise<DeleteItemMedicaoResponse> {
    try {
      const result = await axiosInstance({}).delete(
        `terceirizacao/ItemMedicao/delete`,
        { data: request },
      );
      const response = handleAxiosResponse<DeleteItemMedicaoResponse>(result);
      return { ...response };
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }
  //#endregion

  //#region Medicao Entrega
  async getAllListagemMedicaoEntrega(
    request: GetAllMedicaoEntregaRequest,
  ): Promise<GetAllMedicaoEntregaResponse> {
    try {
      const result = await axiosInstance({}).post(
        `terceirizacao/Medicao/listMedicaoEntrega`,
        request,
      );
      const response =
        handleAxiosResponse<GetAllMedicaoEntregaResponse>(result);
      return { ...response };
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }
  async getAllFormularioAvaliacao(
    request: GetFormularioAvaliacaoFornecedorRequest,
  ): Promise<GetFormularioAvaliacaoFornecedorResponse> {
    try {
      const result = await axiosInstance({}).post(
        `terceirizacao/medicao/dadosFormularioAvalicao`,
        request,
      );
      const response =
        handleAxiosResponse<GetFormularioAvaliacaoFornecedorResponse>(result);
      return { ...response };
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }
  async getAvaliacaoFornecedor(
    request: GetAvaliacaoFornecedorRequest,
  ): Promise<GetAvaliacaoFornecedorResponse> {
    try {
      const result = await axiosInstance({}).post(
        `/terceirizacao/medicao/avaliacoes`,
        request,
      );
      const response =
        handleAxiosResponse<GetAvaliacaoFornecedorResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }
  async updateAvaliacao(
    request: UpdateAvaliacaoRequest,
  ): Promise<UpdateAvaliacaoResponse> {
    try {
      const result = await axiosInstance({}).post(
        `terceirizacao/medicao/saveDadosFormularioAvalicao`,
        request,
      );
      const response = handleAxiosResponse<UpdateAvaliacaoResponse>(result);
      return { ...response };
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  //#endregion

  //#region FuncionarioTerc
  async getAllListagemFuncionarioTerc(
    request: GetAllFuncionarioTercRequest,
  ): Promise<GetAllFuncionarioTercResponse> {
    try {
      const result = await axiosInstance({}).post(
        `terceirizacao/FuncionarioTerc/listFuncionarioTerc`,
        request,
      );
      const response =
        handleAxiosResponse<GetAllFuncionarioTercResponse>(result);
      return { ...response };
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }
  async alterarInativoAtivoFuncionarios(
    request: AlterarInativoAtivoRequest,
  ): Promise<AlterarInativoAtivoResponse> {
    try {
      const result = await axiosInstance({}).post(
        `terceirizacao/FuncionarioTerc/alterarInativoAtivo`,
        request,
      );
      const response = handleAxiosResponse<AlterarInativoAtivoResponse>(result);
      return { ...response };
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }
  async createFuncionariosTerc(
    request: CreatFuncionariosTercRequest,
  ): Promise<CreatFuncionariosTercResponse> {
    try {
      const result = await axiosInstance({}).post(
        `terceirizacao/FuncionarioTerc/create`,
        request,
      );
      const response =
        handleAxiosResponse<CreatFuncionariosTercResponse>(result);
      return { ...response };
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }
  async updateFuncionariosTerc(
    request: UpdateFuncionariosTercRequest,
  ): Promise<UpdateFuncionariosTercResponse> {
    try {
      const result = await axiosInstance({}).post(
        `terceirizacao/FuncionarioTerc/update`,
        request,
      );
      const response =
        handleAxiosResponse<UpdateFuncionariosTercResponse>(result);
      return { ...response };
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }
  async deleteFuncionariosTerc(
    request: DeleteFuncionariosTercRequest,
  ): Promise<DeleteFuncionariosTercResponse> {
    try {
      const result = await axiosInstance({}).delete(
        `terceirizacao/FuncionarioTerc/delete`,
        { data: request },
      );
      const response =
        handleAxiosResponse<DeleteFuncionariosTercResponse>(result);
      return { ...response };
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async createCentroCustoSecundario(
    request: CreatCentroCustoSecundarioRequest,
  ): Promise<CreatCentroCustoSecundarioResponse> {
    try {
      const result = await axiosInstance({}).post(
        `terceirizacao/centro-custo-secundario/create`,
        request,
      );
      const response =
        handleAxiosResponse<CreatCentroCustoSecundarioResponse>(result);
      return { ...response };
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async updateCentroCustoSecundario(
    request: UpdateCentroCustoSecundarioRequest,
  ): Promise<UpdateCentroCustoSecundarioResponse> {
    try {
      const result = await axiosInstance({}).post(
        `terceirizacao/centro-custo-secundario/update`,
        request,
      );
      const response =
        handleAxiosResponse<UpdateCentroCustoSecundarioResponse>(result);
      return { ...response };
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async getCentroCustoSecundarios(
    request: GetCentroCustoSecundariosRequest,
  ): Promise<GetCentroCustoSecundariosResponse> {
    try {
      const result = await axiosInstance({}).post(
        `/terceirizacao/centro-custo-secundario/centro-custo-secundario`,
        request,
      );
      const response =
        handleAxiosResponse<GetCentroCustoSecundariosResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }
  async deleteCentroCustoSecundario(
    request: DeleteCentroCustoSecundarioRequest,
  ): Promise<DeleteCentroCustoSecundarioResponse> {
    try {
      const result = await axiosInstance({}).delete(
        `/terceirizacao/centro-custo-secundario/delete/`,
        { data: request },
      );
      const response =
        handleAxiosResponse<DeleteCentroCustoSecundarioResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async getDocumentos(
    request: GetDocumentosRequest,
  ): Promise<GetDocumentosResponse> {
    try {
      const result = await axiosInstance({}).post(
        `/terceirizacao/documentos/listDocumentos`,
        request,
      );
      const response = handleAxiosResponse<GetDocumentosResponse>(result);
      return { ...response };
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async createDocumento(
    request: CreateDocumentoRequest,
  ): Promise<CreateDocumentoResponse> {
    try {
      const formData = RequestObjectToFormData(request);
      const options = { headers: { "Content-Type": "multipart/form-data" } };
      const result = await axiosInstance({}).post(
        `/terceirizacao/documentos/create`,
        formData,
        options,
      );
      const response = handleAxiosResponse<CreateDocumentoResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async updateDocumento(
    request: UpdateDocumentoRequest,
  ): Promise<UpdateDocumentoResponse> {
    try {
      const formData = RequestObjectToFormData(request);
      const options = { headers: { "Content-Type": "multipart/form-data" } };
      const result = await axiosInstance({}).post(
        `/terceirizacao/documentos/update`,
        formData,
        options,
      );
      const response = handleAxiosResponse<UpdateDocumentoResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async deleteDocumento(
    request: DeleteDocumentoRequest,
  ): Promise<DeleteDocumentoResponse> {
    try {
      const result = await axiosInstance({}).delete(
        `/terceirizacao/documentos/delete/${request.idDocumento}`,
      );
      const response = handleAxiosResponse<DeleteDocumentoResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }
  async downloadFuncionarioDocumentoById({
    idFuncionarioArquivo,
  }: DownloadFuncionarioDocumentoByIdRequest): Promise<Blob> {
    try {
     const result = await axiosInstance().get(
      `/terceirizacao/documentos/${idFuncionarioArquivo}/download`,
      { responseType: "blob" }
    );
      const response = handleAxiosResponse<Blob>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async getFuncionarioTreinamentos(
    request: GetFuncionarioTreinamentosRequest,
  ): Promise<GetFuncionarioTreinamentosResponse> {
    try {
      const result = await axiosInstance({}).post(
        `/terceirizacao/treinamentos/listTreinamentos`,
        request,
      );
      const response =
        handleAxiosResponse<GetFuncionarioTreinamentosResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }
  async createAvaliacaoTreinamento(
    request: CreateAvaliacaoTreinamentoRequest,
  ): Promise<CreateAvaliacaoTreinamentoResponse> {
    try {
      const result = await axiosInstance({}).post(
        `/terceirizacao/treinamentos/create`,
        request,
      );
      const response =
        handleAxiosResponse<CreateAvaliacaoTreinamentoResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }
  async updateAvaliacaoTreinamento(
    request: UpdateAvaliacaoTreinamentoRequest,
  ): Promise<UpdateAvaliacaoTreinamentoResponse> {
    try {
      const result = await axiosInstance({}).post(
        `/terceirizacao/treinamentos/update`,
        request,
      );
      const response =
        handleAxiosResponse<UpdateAvaliacaoTreinamentoResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }
  async deleteFuncionarioTreinamento(
    request: DeleteFuncionarioTreinamentoRequest,
  ): Promise<DeleteFuncionarioTreinamentoResponse> {
    try {
      const result = await axiosInstance({}).delete(
        `/terceirizacao/treinamentos/delete/${request.idFuncionarioTreinamento}`,
      );
      const response =
        handleAxiosResponse<DeleteFuncionarioTreinamentoResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }
  async avaliarTreinamento(
    request: AvaliarTreinamentoRequest,
  ): Promise<AvaliarTreinamentoResponse> {
    try {
      const result = await axiosInstance({}).post(
        `/terceirizacao/funcionarios/treinamentos/avaliar`,
        request,
      );
      const response = handleAxiosResponse<AvaliarTreinamentoResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }
  async avaliarTreinamentoLote(
    request: AvaliarTreinamentoLoteRequest,
  ): Promise<AvaliarTreinamentoLoteResponse> {
    try {
      const result = await axiosInstance({}).post(
        `/terceirizacao/avaliacao-treinamento-lote/avaliar`,
        request,
      );
      const response =
        handleAxiosResponse<AvaliarTreinamentoLoteResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }
  async getAllAvaliacaoTreinamentoLote(
    request: GetAllAvaliacaoTreinamentoLoteRequest,
  ): Promise<GetAllAvaliacaoTreinamentoLoteResponse> {
    try {
      const result = await axiosInstance({}).post(
        `/terceirizacao/avaliacao-treinamento-lote`,
        request,
      );
      const response =
        handleAxiosResponse<GetAllAvaliacaoTreinamentoLoteResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }
  async getAllTreinamentoFuncionario(
    request: GetAllTreinamentoFuncionarioRequest,
  ): Promise<GetAllTreinamentoFuncionarioResponse> {
    try {
      const result = await axiosInstance({}).post(
        `/terceirizacao/treinamento-funcionario`,
        request,
      );
      const response =
        handleAxiosResponse<GetAllTreinamentoFuncionarioResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }
  async saveTreinamentoFuncionario(
    request: SaveTreinamentoFuncionarioRequest,
  ): Promise<SaveTreinamentoFuncionarioResponse> {
    try {
      const result = await axiosInstance({}).post(
        `/terceirizacao/treinamento-funcionario/save`,
        request,
      );
      const response =
        handleAxiosResponse<SaveTreinamentoFuncionarioResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async getAllTreinamentoFuncionarioTercData(
    _: GetAllTreinamentoFuncionarioTercDataRequest,
  ): Promise<GetAllTreinamentoFuncionarioTercDataResponse> {
    try {
      const result = await axiosInstance({}).get(
        `/terceirizacao/treinamento-funcionario/data`,
      );
      const response =
        handleAxiosResponse<GetAllTreinamentoFuncionarioTercDataResponse>(
          result,
        );
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }
  async getAllTreinamentoFuncionarioTercInstrutor(
    request: GetAllTreinamentoFuncionarioTercInstrutorRequest,
  ): Promise<GetAllTreinamentoFuncionarioTercInstrutorResponse> {
    try {
      const result = await axiosInstance({}).get(
        `/terceirizacao/treinamento-funcionario/instrutor/${request.data}`,
      );
      const response =
        handleAxiosResponse<GetAllTreinamentoFuncionarioTercInstrutorResponse>(
          result,
        );
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }
  async getAllTreinamentoFuncionarioTercLocal(
    request: GetAllTreinamentoFuncionarioTercLocalRequest,
  ): Promise<GetAllTreinamentoFuncionarioTercLocalResponse> {
    try {
      const result = await axiosInstance({}).post(
        `/terceirizacao/treinamento-funcionario/local`,
        request,
      );
      const response =
        handleAxiosResponse<GetAllTreinamentoFuncionarioTercLocalResponse>(
          result,
        );
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }
  //#endregion
  //#region Principal
  async getAllIndicadores(): Promise<GetAllIndicadoresResponse> {
    try {
      const result = await axiosInstance({}).get("/terceirizacao/indicadores");
      const rawData = handleAxiosResponse<TercIndicadores>(result);
      const response: GetAllIndicadoresResponse = {
        indicadores: rawData,
      };
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }
  //#endregion

  async downloadContratoArquivo({
    idContratoArquivo,
  }: DownloadContratoArquivoRequest): Promise<Blob> {
    try {
      const result = await axiosInstance().get(`/terceirizacao/contratoArquivo/contratoArquivo/${idContratoArquivo}/download`, { responseType: "blob" });
      const response = handleAxiosResponse<Blob>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }
}
